import React from 'react';
import styled from 'styled-components';
import { ILogoProps, Logo } from './Logo';
import { useResponsive, useWindowDimensions } from '../../hooks/useResponsive/useResponsive';
import { SIZES } from '../../fundamentals/sizes/sizes';

export interface IHeaderLogoProps extends Omit<ILogoProps, 'placement'> {
  breakAt?: keyof Pick<ReturnType<typeof useResponsive>, 'isTablet' | 'isMobile'>;
}

export const HeaderLogo = styled(({ breakAt = 'isMobile', size = SIZES.SMALL, ...rest }: IHeaderLogoProps) => {
  const { isMobile, isTablet } = useWindowDimensions();
  const placement = (breakAt === 'isTablet' && isTablet) || (breakAt === 'isMobile' && isMobile) ? 'mark' : 'header';

  return <Logo placement={placement} size={size} {...rest} />;
})``;
